import React from "react";
import KanbanSpacePage from "./KanbanSpacePage";
import useKanbanSpace from "./useKanbanSpace";

function KanbanSpace(props) {
  return <KanbanSpacePage {...useKanbanSpace(props)} />;
}

export default KanbanSpace;
